var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsNotEmpty, IsString, IsUUID, IsNumber, IsOptional, IsBoolean, } from 'class-validator';
export class GetUnitTreeOptionsDto {
}
__decorate([
    IsNotEmpty(),
    IsString(),
    __metadata("design:type", String)
], GetUnitTreeOptionsDto.prototype, "query", void 0);
__decorate([
    IsNotEmpty(),
    IsNumber(),
    __metadata("design:type", Number)
], GetUnitTreeOptionsDto.prototype, "limit", void 0);
__decorate([
    IsNotEmpty(),
    IsNumber(),
    __metadata("design:type", Number)
], GetUnitTreeOptionsDto.prototype, "offset", void 0);
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], GetUnitTreeOptionsDto.prototype, "company_id", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], GetUnitTreeOptionsDto.prototype, "unit_type", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], GetUnitTreeOptionsDto.prototype, "query_include_root", void 0);
